import {useQuery} from '@tanstack/react-query'
import React from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getPostList} from '../../../apis/post/getPostList'
import {getAnnounceList} from '../../../apis/announce/getAnnounceList'

const useQueryAnnounceList = (currentPage: number = 1) => {
    const PAGE_SIZE = 10
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.announce.getAnnounceList(currentPage),
        queryFn: async () => {
            const {data, pageInfo} = await getAnnounceList(currentPage, PAGE_SIZE)
            return {data, pageInfo}
        },
    })
    return {data, refetch}
}

export default useQueryAnnounceList
